import { ReactNode } from 'react';

import round from 'lodash/round';

import {
  RatioProgressBar,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

type Props = { value?: number; available?: ReactNode; testId?: string };

export const NodeResourceUsageCell = ({
  value,
  available,
  testId = 'node-resource-usage',
}: Props) => {
  if (value === undefined) {
    return <span data-value={0}>-</span>;
  }

  return (
    <Stack display="flex" gap="2px" data-testid={testId} data-value={value}>
      <Stack
        direction="row"
        justifyContent={available ? 'space-between' : 'flex-end'}
      >
        {available && (
          <Typography variant="inherit" noWrap data-testid="available">
            {available}
          </Typography>
        )}

        <Typography
          variant="inherit"
          color="textSecondary"
          noWrap
          data-testid="value"
        >
          {round(value)}%
        </Typography>
      </Stack>

      <RatioProgressBar
        hideBorders
        size="md"
        // Semantic track color so the "unfilled" portion stays readable in dark mode.
        sx={{ backgroundColor: tokens.theme.bg.structural.surfaceRaised }}
        total={100}
        bars={[{ value, color: tokens.theme.data.blue300 }]}
      />
    </Stack>
  );
};
